import './Stats.scss';
import Component from './Stats.js';
export default Component;
